import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sera-horizontal-line',
    templateUrl: './sera-horizontal-line.component.html',
    styleUrls: ['./sera-horizontal-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraHorizontalLineComponent {}
